import { APP_ID, appUrl, type PlatformAppId } from "../config/environment";
import {
  createFrontendSession,
  type FrontendSession as SharedSession,
} from "../../../shared/frontendSession";
export type FrontendSession = SharedSession<PlatformAppId>;
export const { getSession, clearSession, requireFrontendSession, signOut } = createFrontendSession(
  APP_ID,
  appUrl,
);
